// @flow

import axios from 'axios';
import { getBaseUrl } from '../../config/config';

export default function getTopExtendedActivities(projectId: string, startDate: string): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/top_extended_activities${startDate ? `?start_date=${startDate}` : ''}`);
}
